import { useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useEmoiChatStore } from '@/stores/emoiChatStore';
import { EmoiPanel } from './EmoiPanel';

export function EmoiBubble() {
  const { t } = useTranslation();
  const isOpen = useEmoiChatStore((s) => s.isOpen);
  const toggle = useEmoiChatStore((s) => s.toggle);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === '/' && !e.shiftKey) {
        e.preventDefault();
        toggle();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [toggle]);

  return (
    <>
      <button
        type="button"
        aria-label={t('emoi.open')}
        onClick={toggle}
        className={[
          'fixed z-40 right-5 bottom-5 md:right-6 md:bottom-6',
          'h-12 w-12 md:h-14 md:w-14 rounded-full',
          'bg-gradient-to-br from-[#7cadda] via-[#dcd5bb] to-[#dda4df]',
          'shadow-vess-btn hover:shadow-vess-lg',
          'flex items-center justify-center',
          'transition-transform duration-200 hover:-translate-y-0.5 active:translate-y-0',
          'border border-white/20',
          isOpen ? 'opacity-0 pointer-events-none' : 'opacity-100',
        ].join(' ')}
      >
        <Sparkles className="h-5 w-5 md:h-6 md:w-6 text-foreground/80" />
      </button>
      <EmoiPanel />
    </>
  );
}
